import { SVG } from '../svg';
import { IconProps } from '../types';

export function ClockIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 10" />
    </SVG>
  );
}
